// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--5-1!./scrollbar.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("86b2e596", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/scrollbar.css
// module id = 591
// module chunks = 8